import React, {Suspense, useContext, useEffect, useState} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import {theme} from "./config/Theme";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";
import LoadingScreen from "./components/loading-screen/LoadingScreen";
import {LoginPage} from "./pages/auth/login/LoginPage";
import {Projects} from "./pages/projects/Projects";
import {SignInContext} from "./context/SignInContext";
import {ReactFlowProvider} from "reactflow";
import UnderMaintenance from "./pages/under-maintenance/UnderMaintenance";
import {ProjectHomePage} from "./pages/project/ProjectHomePage";
import {RegisterPage} from "./pages/auth/register/RegisterPage";
import {Organizations} from "./pages/organizations/Organizations";
import {AiModels} from "./pages/ai-models/AiModels";
import {OAuthSuccess} from "./pages/auth/login/OAuthSuccess";
import {ProjectCreationPage} from "./pages/project-creation/ProjectCreationPage";
import {MainLayout} from "./layouts/main-layout/MainLayout";
import {LandingPage} from "./pages/landing/landing-page";
import {ChangePasswordPage} from "./pages/auth/change-password/ChangePasswordPage";
import {ForgotPasswordPage} from "./pages/auth/forgot-password/ForgotPassword";
import "react-datepicker/dist/react-datepicker.css";
import {ConfirmDialogModal} from "./components/modals/ConfirmDialogModal";
import isElectron from "./utils/functions";
import {ProjectElectronLayout} from "./pages/project/project-electron-layout";

export const App = () => {
  const {isAuth} = useContext(SignInContext);
  const [isElectronApp, setIsElectronApp] = useState(null);

  useEffect(() => {
    const response = isElectron();
    setIsElectronApp(response);
  }, []);

  if (isAuth === null || isElectronApp === null) {
    return <LoadingScreen />
  }

  if (isElectronApp) {
    return (
      <ThemeProvider theme={theme}>
        <ReactFlowProvider>
          <ToastContainer theme={"colored"}/>
          <Suspense fallback={<LoadingScreen/>}>
            <ConfirmDialogModal/>
            <Routes>
              <Route path="/under-maintenance" exact index element={<UnderMaintenance/>}/>

              {
                !isAuth ?
                  <>
                    <Route path="/login" index element={<LoginPage/>}/>
                    <Route path="/register" index element={<RegisterPage/>}/>
                    <Route path="/forgot-password" index element={<ForgotPasswordPage/>}/>
                    <Route path="/change-password" index element={<ChangePasswordPage/>}/>
                    <Route path="/oauth2/redirect" index element={<OAuthSuccess/>}/>
                    <Route path="*" element={<Navigate to="/login"/>}/>
                  </>
                  :
                  <>
                    <Route element={<MainLayout/>}>
                      <Route path="/projects" exact index element={<Projects/>}/>
                      <Route path="/project/create" exact index element={<ProjectCreationPage/>}/>
                    </Route>
                    <Route path="/project/:projectId/supervision/:conversationId" element={<ProjectElectronLayout/>}/>
                    <Route path="/project/:projectId/supervision" element={<ProjectElectronLayout/>}/>
                    <Route path="/project/:projectId/" element={<ProjectElectronLayout/>}/>
                    <Route path="*" element={<Navigate to="/projects"/>}/>
                  </>
              }
            </Routes>
          </Suspense>
        </ReactFlowProvider>
      </ThemeProvider>
    )
  }


  return (
    <ThemeProvider theme={theme}>
      <ReactFlowProvider>
        <ToastContainer theme={"colored"} position={"bottom-right"}/>
        <Suspense fallback={<LoadingScreen/>}>
          <ConfirmDialogModal/>
          <Routes>
            <Route path="/under-maintenance" exact index element={<UnderMaintenance/>}/>

            {
              !isAuth ?
                <>
                  <Route path="/" exact index element={<LandingPage/>}/>
                  <Route path="/login" index element={<LoginPage/>}/>
                  <Route path="/register" index element={<RegisterPage/>}/>
                  <Route path="/forgot-password" index element={<ForgotPasswordPage/>}/>
                  <Route path="/change-password" index element={<ChangePasswordPage/>}/>
                  <Route path="/oauth2/redirect" index element={<OAuthSuccess/>}/>
                  <Route path="*" element={<Navigate to="/login"/>}/>
                </>
                :
                <>
                  <Route element={<MainLayout/>}>
                    {/*<Route path="/" exact index element={<Projects/>}/>*/}
                    <Route path="/organizations" exact index element={<Organizations/>}/>
                    <Route path="/ai-models" exact index element={<AiModels/>}/>
                    <Route path="/projects" exact index element={<Projects/>}/>
                    <Route path="/project/create" exact index element={<ProjectCreationPage/>}/>
                  </Route>

                  <Route path="/project/edit/:projectId" exact index element={<ProjectCreationPage/>}/>
                  <Route path="/project/:projectId/*" element={<ProjectHomePage/>}/>
                  <Route path="*" element={<Navigate to="/projects"/>}/>
                </>
            }
          </Routes>
        </Suspense>
      </ReactFlowProvider>
    </ThemeProvider>
  );
}
